import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';

import filterReconFields from 'constants/filterReconFields';

import initialState from './initialState';
import actionTypes from './actionTypes';

const refDatareportConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_REPORTS_BY_GROUP_SUCCESS:
            return {
                ...state,
                reportsByGroups: action.payload,
            };
        case actionTypes.GET_REF_DATA_REPORT_FIELD_MAPPING_SUCCESS: {
            const { unMappedReconFields = [] } = action.payload;
            let clonedMappedDict;
            clonedMappedDict = _cloneDeep(unMappedReconFields);
            filterReconFields.map((field) => {
                clonedMappedDict.push({
                    field_name: field.name,
                    value: field.label,
                    field_type: field.type,
                });
            });
            return {
                ...state,
                reportMappings: action.payload,
                clonedMappedDict,
            };
        }
        case actionTypes.RESET_REPORT_FIELD_MAPPING_SUCCESS: {
            return {
                ...state,
                reportMappings: [],
                clonedMappedDict: [],
            };
        }
        case actionTypes.GET_REPORT_GROUP_FIELD_EXPRESSION:
            return {
                ...state,
                reportReconFieldExpressions: action.payload,
            };
        case actionTypes.GET_REPORT_RECON_MAPPINGS:
            return {
                ...state,
                reportReconFieldMaps: action.payload,
            };

        case actionTypes.GET_NEW_REPORT_FIELD_MAPPING_SUCCESS:
            return {
                ...state,
                reportFieldMappings: {
                    mappedDataDictionary: _get(action.payload, 'mappedDataDictionary', [])
                    , unMappedDataDictionary: [], reconFieldMappings: _get(action.payload, 'reconFieldMappings', []),

                },
                reconFieldColumnNames: _get(action.payload, 'reconFieldMappings', []),
            };
        default:
            return state;
    }
};

export default refDatareportConfigurationReducer;
